<template>
<div>
  <el-dialog
    title="导入月份选择"
    :visible.sync="dialogVisible"
    width="270px"
    :close-on-click-modal="false" @close="onClose">
    <el-date-picker
      v-model="import_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="选择导入的月份" :clearable="false">
    </el-date-picker>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="submit">确 定</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: "SelectMonth",
  data(){
    return{
      dialogVisible:false,
      import_month:"",
      callback:null
    }
  },
  methods:{
    show(def_month=null,callback){
      if(def_month){
        this.import_month=def_month;
      }
      this.callback=callback;
      this.dialogVisible=true;
    },
    submit(){
      const that=this;
      if(typeof that.callback==="function"){
        that.callback(that.import_month)
      }
      that.dialogVisible=false;
    },
    onClose(){
      this.callback=undefined;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/legal/SelectMonth.vue